import { render, staticRenderFns } from "./LifeCycles.vue?vue&type=template&id=225aa6a6"
import script from "./LifeCycles.vue?vue&type=script&lang=js"
export * from "./LifeCycles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports